import _extends from 'babel-runtime/helpers/extends';
import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';
import _typeof from 'babel-runtime/helpers/typeof';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
// @todo investigate if we can change requirements to use Intl.NumberFormat instead of currencyValueTemplates.
export var currencyValueTemplates = {
  GBP: '{{sign}}£{{amount}}',
  EUR: '{{sign}}€{{amount}}',
  AUD: '{{sign}}AUD {{amount}}',
  CAD: '{{sign}}CAD {{amount}}',
  USD: '{{sign}}${{amount}}',
  DKK: '{{sign}}Kr. {{amount}}',
  JPY: '{{sign}}¥{{amount}}',
  SGD: '{{sign}}SGD {{amount}}',
  HKD: '{{sign}}HKD {{amount}}',
  CHF: '{{sign}}CHF {{amount}}'
};

var getCurrencyTemplate = function getCurrencyTemplate(currency) {
  return Object.prototype.hasOwnProperty.call(currencyValueTemplates, currency) ? currencyValueTemplates[currency] : currencyValueTemplates['GBP'];
};

var getSign = function getSign(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      useExplicitSign = _ref.useExplicitSign;

  var parsedValue = +value;

  if (isNaN(parsedValue)) {
    throw new Error('Invalid currency amount. Expected to be formatted to number, got NaN from: ' + value);
  }

  switch (true) {
    case parsedValue === 0:
      return '';
    case parsedValue < 0:
      return '-';
    case useExplicitSign:
      return '+';
    default:
      return '';
  }
};

var removeDecimals = function removeDecimals(value) {
  return Number(value).toString();
};

var makeValuePositive = function makeValuePositive(value) {
  return Number(removeDecimals(Math.abs(value)));
};

// @todo MYACC-2004 get rid of currencySignFormatter method and use this instead
export var formatAmountWithCurrency = function formatAmountWithCurrency(amount, currency) {
  var useExplicitSign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var amountNumber = Number(amount);
  var positiveSign = useExplicitSign && amountNumber !== 0 ? '+' : '';
  var sign = amountNumber < 0 ? '-' : positiveSign;
  var amountWithCommas = makeValuePositive(amount).toLocaleString('en-US');
  var currencyValueTemplate = currencyValueTemplates[currency] || currencyValueTemplates['GBP'];
  return currencyValueTemplate.replace('{{sign}}', sign).replace('{{amount}}', amountWithCommas);
};

// formatter for P&L only
// keeping it here for simplifying refactoring
// so it will be easier to decominish legacy
var formatCurrency = function formatCurrency(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var locale = _ref2.locale,
      _ref2$withSign = _ref2.withSign,
      withSign = _ref2$withSign === undefined ? true : _ref2$withSign,
      useExplicitSign = _ref2.useExplicitSign,
      currency = _ref2.currency,
      options = _objectWithoutProperties(_ref2, ['locale', 'withSign', 'useExplicitSign', 'currency']);

  if (!['string', 'number'].includes(typeof value === 'undefined' ? 'undefined' : _typeof(value))) {
    return '';
  }
  if (typeof value === 'string' && _Number$isNaN(+value)) {
    return '';
  }
  if (!['string', 'undefined'].includes(typeof locale === 'undefined' ? 'undefined' : _typeof(locale))) {
    return '';
  }

  var sign = '';

  if (withSign || useExplicitSign) {
    sign = getSign(value, { useExplicitSign: useExplicitSign });
  }

  var formatter = new Intl.NumberFormat(locale, _extends({ minimumFractionDigits: 2, maximumFractionDigits: 2 }, options));

  var parsedValue = formatter.format(Math.abs(+value));

  return getCurrencyTemplate(currency).replace('{{sign}}', sign).replace('{{amount}}', parsedValue);
};
export { formatCurrency };